// extracted by mini-css-extract-plugin
module.exports = {"container":"_26vpVqsJHKd4DlhGwJFcdG"};